import { combineLatest, of, Subject } from "rxjs";
import * as _ from "lodash";
import { IGlobal } from "config/config.interface";
import { ToastService } from "./toast.service";
import { AjaxRequest } from "rxjs/ajax";
import { catchError, map } from "rxjs/operators";

export class InMemoryList {
    protected _list: any[] = [];
    protected _newList: any = {};
    protected globalConfig: IGlobal = (global as any as IGlobal);
    protected toastService: ToastService = new ToastService();

    public baseAdd(item: any, key?: any, replace = false) {
        if (key) {
            const list = this._newList[key];
            if (list && !replace) {
                list.push(item);
            } else {
                this._newList[key] = item;
            }
        } else {
            if (this._newList['all']) {
                this._newList['all'].push(item)
            } else {
                this._newList['all'] = [item]
            }
        }
    }
    public getItems() {
        return this._newList;
    }

    public createKey(input: string): number {
        var hash = 0;
        if (input.length === 0) return hash;
        for (let x = 0; x < input.length; x++) {
            const ch = input.charCodeAt(x);
            hash = ((hash << 5) - hash) + ch;
            hash = hash & hash;
        }
        return Math.abs(hash);
    }

    protected findItemKey(matchProperty: any, itemProperty: any): string {
        let foundItem: string = "";
        _.each(_.toPairs(this._newList), (listItem: any) => {
            if (_.get(listItem[1], matchProperty) === itemProperty) {
                // this is a match and we need to remove it
                foundItem = listItem[0];
            }
        });
        return foundItem;
    }
}

export class ApiBus extends InMemoryList {
    _retryList: any[] = [];
    _currentlyRetrying = false;
    constructor() {
        super();
        this.checkForReQueue();
    }

    public add(item: any, key?: any, replace = false) {

        if (!window.navigator.onLine) {
            if (!this._currentlyRetrying)
                this.toastService.infoWithTimer('Attempting to save response(s)...');
            this._currentlyRetrying = true;
            if (key) {
                key = key.toString();
                const list = this._retryList[key];
                if (list && !replace) {
                    list.push(item);
                } else {
                    this._retryList[key] = item;
                }
            } else {
                if (this._retryList['all' as any]) {
                    this._retryList['all' as any].push(item)
                } else {
                    this._retryList['all' as any] = [item]
                }
            }
        } else {
            this.baseAdd(item, key, replace)
        }
    }

    public execute(): Subject<AjaxRequest[]> {
        return combineLatest(_.values(this._newList)) as any;
    }

    private executeRetries(): any {
        const retryList = _.values(this._retryList);
        return combineLatest(retryList.filter(r => r));
    }

    public removeItem(item: any, keyOverride?: string | number) {
        if (keyOverride) {
            delete this._newList[keyOverride];
            return;
        }
        const key = this.findItemKey('source.request.url', item.request.url);
        if (key)
            delete this._newList[key];
    }

    public clearRetries() {
      this._retryList = [];
      this._currentlyRetrying = false;
    }

    public reQueueItem(item: any, optionalKey = "") {
        let key = "";
        if (optionalKey && optionalKey.length > 0) {
            key = optionalKey;
        } else {
            key = this.findItemKey('source.request.url', item);
        }

        if (key) {
            if (!this._currentlyRetrying) {
                this.toastService.clearToast();
                this.toastService.infoWithTimer('Attempting to save response(s)...');
                this._currentlyRetrying = true;
            }

            const match = this._newList[key];

            this._retryList.push(match);
            delete this._newList[key];
        }
    }

    // Every 30s we will check the API bus to see if anything is marked for requeue - if so, we will try to send it.
    private checkForReQueue() {
        setInterval(() => {
            if (this._newList && Object.keys(this._newList).length > 0) {
              this.execute()
                .pipe(
                  catchError(error => {
                    var qp = error.request && error.request.queryParams ? error.request.queryParams.QuestionID.toString() : "";
                    this.reQueueItem(error, qp);
                    return of(error);
                  }),
                  map(response => {
                    response.forEach((item: any) => {
                      this.removeItem(item, (item as any).request.queryParams.QuestionID);
                    })
                    return response;
                  })
                ).subscribe();
            }
            if (this._retryList && this._retryList.length > 0 && window.navigator.onLine) {
                let foundData = false;
                this.executeRetries().subscribe({
                    next: () => {
                        foundData = true;
                        this._retryList = [];
                        this._currentlyRetrying = false;
                    },
                    complete: () => {
                        if (foundData) {
                            this.toastService.clearToast(true);
                            this.toastService.success('Successfully saved!');
                        }
                    }
                })
            }
        }, 30000);
    }
}
